// extracted by mini-css-extract-plugin
export default {"root":"widget-athlete-list-medium_root__Veniq"};